import { render, staticRenderFns } from "./LoginFail.vue?vue&type=template&id=208ce5c5&"
import script from "./LoginFail.vue?vue&type=script&lang=js&"
export * from "./LoginFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/aalzahr/mwc-components-common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208ce5c5')) {
      api.createRecord('208ce5c5', component.options)
    } else {
      api.reload('208ce5c5', component.options)
    }
    module.hot.accept("./LoginFail.vue?vue&type=template&id=208ce5c5&", function () {
      api.rerender('208ce5c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoginForm/LoginFail.vue"
export default component.exports